import { QuestionStatus } from '@report/graphql';
import { type GridColDef, LabelColor, Text, Label } from '@shared/components';

const QUESTION_STATUS_COLOR: Record<QuestionStatus, LabelColor> = {
  [QuestionStatus.Published]: LabelColor.SUCCESS,
  [QuestionStatus.Disabled]: LabelColor.GREY,
};

const QUESTION_STATUS_TEXT: Record<QuestionStatus, string> = {
  [QuestionStatus.Published]: 'Published',
  [QuestionStatus.Disabled]: 'Disabled',
};

export interface PAnalysisListItem {
  id: string;
  order: number;
  code: string;
  pInitial: JSX.Element | string;
  pUse: JSX.Element | string;
  status: QuestionStatus;
  bIndex: number | null;
  pCalculated: JSX.Element | string;
  pBuffer: JSX.Element | string;
  indicative:
    | {
        label: string;
        color: LabelColor;
        diff: number;
      }
    | string;
}

export const pAnalysisListColumns: GridColDef<PAnalysisListItem>[] = [
  {
    field: 'order',
    headerName: 'No.',
    width: 64,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.order}</Text>;
    },
  },
  {
    field: 'code',
    headerName: 'QID',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => {
      return <Text>{row.code}</Text>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      return (
        <Label
          sx={{
            borderRadius: (theme) => theme.shape.rounded(7),
          }}
          size='small'
          color={QUESTION_STATUS_COLOR[row.status]}
        >
          {QUESTION_STATUS_TEXT[row.status]}
        </Label>
      );
    },
  },
  {
    field: 'bIndex',
    headerName: 'B-Index',
    width: 124,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <Text>{row.bIndex ?? '-'}</Text>;
    },
  },
  {
    field: 'pInitial',
    headerName: 'P Initial',
    width: 124,
    headerAlign: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return row.pInitial;
    },
  },
  {
    field: 'pUse',
    headerName: 'P Use',
    width: 124,
    headerAlign: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return row.pUse;
    },
  },
  {
    field: 'pCalculated',
    headerName: 'P Cal',
    width: 124,
    headerAlign: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return row.pCalculated;
    },
  },
  {
    field: 'pBuffer',
    headerName: 'P Buffer',
    width: 124,
    headerAlign: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return row.pBuffer;
    },
  },
  {
    field: 'indicative',
    headerName: 'Indicative',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      if (typeof row.indicative === 'string') {
        return <Text>{row.indicative}</Text>;
      }
      return (
        <Label
          color={row.indicative.color}
          variant='outlined'
          size='small'
          sx={{
            borderRadius: (theme) => theme.shape.rounded(7),
            p: (theme) => theme.spacing(0.5, 2),
          }}
        >
          {row.indicative.label}
        </Label>
      );
    },
  },
];
